import { BookmarksSideBarMenu } from "client/Features/Documents/Bookmarks/BookmarksSideBarMenu";
import { ReactElement, useCallback } from "react";
import { IStoreHistoryState } from "client_legacy/Documents/documentStore";
import { getUrlForHistoryState } from "client/Features/Documents/DocumentPage";
import { DocumentStoreType } from "client/Api/Documents/common";
import { navigateTo } from "client_legacy/ndaw/navigator";
import { userConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { DestinationWindow } from "client/Api/Apps/common";

export const BookmarksSection = (): ReactElement => {
	const navigateToBookmarks = useCallback(
		(): void => {
			const historyState: IStoreHistoryState = {
				store: DocumentStoreType.Bookmarks
			};

			const url: string = getUrlForHistoryState(historyState);

			const { destinationWindow } = userConfiguration().document;

			navigateTo(
				url,
				destinationWindow === DestinationWindow.NewWindow
			);
		},
		[]
	);

	return (
		<BookmarksSideBarMenu
			isSelected={false}
			onClick={navigateToBookmarks}
		/>
	);
};
BookmarksSection.displayName = "BookmarksSection";